(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content-with-toc"] && !Shopify.designMode) return;
  try {
    class BlogPostTableOfContents extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready !== undefined) return;

      const headings = this.querySelectorAll('.blog-post-content h2');
      const tocLinks = this.querySelectorAll('.article-toc__list > li:not(.article-toc__cta) > a');

      headings.forEach((heading, index) => {
        const target = tocLinks[index]?.getAttribute('href');

        if (target?.startsWith('#')) heading.id = target.slice(1);
      });

      this.dataset.ready = '';
    }
  }

  if (!customElements.get('blog-post-table-of-contents')) {
    customElements.define('blog-post-table-of-contents', BlogPostTableOfContents);
  }
  } catch(e) { console.error(e); }
})();

})();
